(() => {
  var __defProp = Object.defineProperty;
  var __defNormalProp = (obj, key, value) => key in obj ? __defProp(obj, key, { enumerable: true, configurable: true, writable: true, value }) : obj[key] = value;
  var __publicField = (obj, key, value) => __defNormalProp(obj, typeof key !== "symbol" ? key + "" : key, value);

  // scripts/sections/collection.ts
  var CollectionAjax = class {
    constructor() {
      __publicField(this, "sectionId");
      __publicField(this, "form");
      __publicField(this, "sortForm");
      __publicField(this, "grid");
      __publicField(this, "wrapper");
      __publicField(this, "trigger");
      __publicField(this, "loading");
      __publicField(this, "nextPage");
      __publicField(this, "filtersToggle");
      __publicField(this, "filtersDrawer");
      __publicField(this, "filtersClose");
      var _a;
      const sectionEl = document.querySelector("[data-collection-template]");
      this.sectionId = (sectionEl == null ? void 0 : sectionEl.dataset.sectionId) || "";
      this.form = document.getElementById("CollectionFilters");
      this.grid = document.getElementById("ProductGrid");
      this.wrapper = document.getElementById("ProductGridWrapper");
      this.trigger = document.getElementById("InfiniteScrollTrigger");
      this.sortForm = document.getElementById("SortForm");
      this.loading = false;
      const nextPageEl = document.querySelector("[data-next-page]");
      this.nextPage = ((_a = nextPageEl == null ? void 0 : nextPageEl.dataset) == null ? void 0 : _a.nextPage) || null;
      this.filtersToggle = document.querySelector("[data-filters-toggle]");
      this.filtersDrawer = document.querySelector("[data-filters-drawer]");
      this.filtersClose = document.querySelectorAll("[data-filters-close]");
      this.init();
    }
    init() {
      if (this.form) {
        this.form.addEventListener("change", () => this.applyFilters());
      }
      if (this.sortForm) {
        this.sortForm.addEventListener("change", () => this.applyFilters());
      }
      this.setupInfiniteScroll();
      const clearBtn = document.querySelector("[data-filters-clear]");
      if (clearBtn) {
        clearBtn.addEventListener("click", () => this.clearFilters());
      }
      if (this.filtersToggle && this.filtersDrawer) {
        this.filtersToggle.addEventListener("click", (e) => {
          e.preventDefault();
          this.filtersDrawer.classList.toggle("is-open");
          document.body.classList.add("is-scroll-disabled");
        });
      }
      if (this.filtersDrawer && this.filtersClose.length) {
        this.filtersClose.forEach((closeBtn) => {
          closeBtn.addEventListener("click", (e) => {
            e.preventDefault();
            this.filtersDrawer.classList.remove("is-open");
            document.body.classList.remove("is-scroll-disabled");
          });
        });
      }
    }
    async applyFilters() {
      if (!this.form) return;
      const filterParams = new URLSearchParams(new FormData(this.form));
      if (this.sortForm) {
        const sortParams = new URLSearchParams(new FormData(this.sortForm));
        sortParams.forEach((value, key) => {
          filterParams.set(key, value);
        });
      }
      const url = `${window.location.pathname}?${filterParams.toString()}`;
      this.setLoading(true);
      const html = await this.fetchSection(url);
      this.replaceGrid(html);
      window.history.replaceState({}, "", url);
      this.setLoading(false);
    }
    async fetchSection(url) {
      const connector = url.includes("?") ? "&" : "?";
      const response = await fetch(`${url}${connector}section_id=${this.sectionId}`);
      const text = await response.text();
      const temp = document.createElement("div");
      temp.innerHTML = text;
      console.log("AJAX Response:", temp.innerHTML);
      return temp;
    }
    replaceGrid(temp) {
      var _a;
      if (!this.grid) return;
      const newGrid = temp.querySelector("#ProductGrid");
      const newCount = temp.querySelector("[data-collection-count]");
      const newActiveFilters = temp.querySelector("[data-active-filters]");
      this.grid.innerHTML = newGrid.innerHTML;
      const activeFiltersTarget = document.querySelector("[data-active-filters]");
      if (activeFiltersTarget && newActiveFilters) {
        activeFiltersTarget.innerHTML = newActiveFilters.innerHTML;
      } else if (activeFiltersTarget && !newActiveFilters) {
        activeFiltersTarget.innerHTML = "";
      }
      if (newCount) {
        const countTargets = document.querySelectorAll("[data-collection-count]");
        countTargets.forEach((el) => {
          el.innerHTML = newCount.innerHTML;
        });
      }
      this.initThumbnails();
      const nextPageEl = temp.querySelector("[data-next-page]");
      this.nextPage = ((_a = nextPageEl == null ? void 0 : nextPageEl.dataset) == null ? void 0 : _a.nextPage) || null;
    }
    appendToGrid(temp) {
      var _a, _b;
      if (!this.grid) return;
      const items = ((_a = temp.querySelector("#ProductGrid")) == null ? void 0 : _a.children) || [];
      [...items].forEach((item) => this.grid.appendChild(item));
      this.initThumbnails();
      const nextPageEl = temp.querySelector("[data-next-page]");
      this.nextPage = ((_b = nextPageEl == null ? void 0 : nextPageEl.dataset) == null ? void 0 : _b.nextPage) || null;
    }
    setLoading(state) {
      var _a;
      this.loading = state;
      (_a = this.wrapper) == null ? void 0 : _a.classList.toggle("loading", state);
    }
    setupInfiniteScroll() {
      if (!this.trigger) return;
      const observer = new IntersectionObserver(
        async (entries) => {
          const entry = entries[0];
          if (entry.isIntersecting && !this.loading && this.nextPage) {
            this.setLoading(true);
            const html = await this.fetchSection(this.nextPage);
            this.appendToGrid(html);
            this.setLoading(false);
          }
        },
        { rootMargin: "300px" }
      );
      observer.observe(this.trigger);
    }
    clearFilters() {
      if (!this.form) return;
      this.form.reset();
      const url = window.location.pathname;
      this.setLoading(true);
      this.fetchSection(url).then((html) => {
        this.replaceGrid(html);
        window.history.replaceState({}, "", url);
        this.setLoading(false);
      });
    }
    initThumbnails() {
      const cards = document.querySelectorAll("[data-product-thumbnail]");
      const observer = new IntersectionObserver(
        (entries, obs) => {
          entries.forEach((entry) => {
            if (entry.isIntersecting) {
              entry.target.classList.add("is-visible");
              var currentQueryString = window.location.search;
              var urlParams = new URLSearchParams(currentQueryString);
              var countryParam = urlParams.get("country");
              if (countryParam) {
                currentQueryString = "?country=" + countryParam;
              } else {
                currentQueryString = "";
              }
              entry.target.querySelectorAll("a").forEach(function(link) {
                var href = link.getAttribute("href");
                if (href && href.startsWith("/") && !href.includes("?country=")) {
                  link.setAttribute("href", href + currentQueryString);
                }
              });
              obs.unobserve(entry.target);
            }
          });
        },
        { threshold: 0.2 }
      );
      cards.forEach((card) => observer.observe(card));
    }
  };
  document.addEventListener("DOMContentLoaded", () => {
    const ajax = new CollectionAjax();
    ajax.initThumbnails();
  });
})();
